var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGraphql(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 20,
    viewBox: "0 0 18 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.15427 14.718L1.87305 15.133L9.88055 1.26401L9.16177 0.849006L1.15427 14.718Z",
    fill: "#E535AB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.0052 13.61H0.990234V14.44H17.0052V13.61Z",
    fill: "#E535AB"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1.30688 14.0763L9.31738 18.7013L9.73238 17.9825L1.72188 13.3575L1.30688 14.0763Z",
    fill: "#E535AB"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.26587 2.02233L16.2764 6.64733L16.6914 5.92855L8.68087 1.30355L8.26587 2.02233Z",
    fill: "#E535AB"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M1.30961 5.92539L1.72461 6.64417L9.73511 2.01917L9.32011 1.30039L1.30961 5.92539Z",
    fill: "#E535AB"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M8.12141 1.26416L16.1289 15.1331L16.8477 14.7181L8.84019 0.849159L8.12141 1.26416Z",
    fill: "#E535AB"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M2.455 5.375H1.625V14.625H2.455V5.375Z",
    fill: "#E535AB"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M16.3749 5.375H15.5449V14.625H16.3749V5.375Z",
    fill: "#E535AB"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M8.81328 17.7221L9.17578 18.35L16.1428 14.3275L15.7803 13.6996L8.81328 17.7221Z",
    fill: "#E535AB"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M17.4748 14.895C16.9948 15.73 15.9248 16.015 15.0898 15.535C14.2548 15.055 13.9698 13.985 14.4498 13.15C14.9298 12.315 15.9998 12.03 16.8348 12.51C17.6748 12.995 17.9598 14.06 17.4748 14.895Z",
    fill: "#E535AB"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M3.54511 6.85C3.06511 7.685 1.99511 7.97 1.16011 7.49C0.325113 7.01 0.0401127 5.94 0.520113 5.105C1.00011 4.27 2.07011 3.985 2.90511 4.465C3.74011 4.95 4.02511 6.015 3.54511 6.85Z",
    fill: "#E535AB"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M0.524996 14.895C0.0449955 14.06 0.329995 12.995 1.165 12.51C2 12.03 3.065 12.315 3.55 13.15C4.03 13.985 3.745 15.05 2.91 15.535C2.07 16.015 1.005 15.73 0.524996 14.895Z",
    fill: "#E535AB"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M14.4547 6.85C13.9747 6.015 14.2597 4.95 15.0947 4.465C15.9297 3.985 16.9947 4.27 17.4797 5.105C17.9597 5.94 17.6747 7.005 16.8397 7.49C16.0047 7.97 14.9347 7.685 14.4547 6.85Z",
    fill: "#E535AB"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M8.99988 19.79C8.03488 19.79 7.25488 19.01 7.25488 18.045C7.25488 17.08 8.03488 16.3 8.99988 16.3C9.96488 16.3 10.7449 17.08 10.7449 18.045C10.7449 19.005 9.96488 19.79 8.99988 19.79Z",
    fill: "#E535AB"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M8.99988 3.7C8.03488 3.7 7.25488 2.92 7.25488 1.955C7.25488 0.989999 8.03488 0.209999 8.99988 0.209999C9.96488 0.209999 10.7449 0.989999 10.7449 1.955C10.7449 2.92 9.96488 3.7 8.99988 3.7Z",
    fill: "#E535AB"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGraphql);
export default __webpack_public_path__ + "static/media/graphql.0646dd493264524cba5af5fd6d91b985.svg";
export { ForwardRef as ReactComponent };